import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { HomeDataBuilder } from './home-data.builder';
import { HomeDataService } from './home-data.service';
import { HomeDataEffects } from './home-data.effects';
import { HomeDataDispatcher } from './home-data.dispatcher';
import { HomeDataStore } from './home-data.store';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { FEATURE_NAME, reducer } from './home-data.reducer';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(FEATURE_NAME, reducer),
    EffectsModule.forFeature([HomeDataEffects]),
  ],
  declarations: [],
})
export class HomeDataModule {
  static forRoot(): ModuleWithProviders<HomeDataModule> {
    return {
      ngModule: HomeDataModule,
      providers: [
        HomeDataBuilder,
        HomeDataService,
        HomeDataDispatcher,
        HomeDataStore,
      ],
    };
  }
}
